<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16C9bn4/tc-custom/9781504077125.jpg?1701400361498" alt="This image is the cover for the book Carer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Carer
      </h1>
      <p class="bookDescription body article font2">
        <b>“[A] social comedy with some brilliant people observations about ageing and a devilish plot twist” from the author of <i>The Best Exotic Marigold Hotel</i> (<i>The Times</i>, London).</b><br/>  <br/> After their elderly father’s fall, Phoebe and her brother, Robert, couldn’t be happier with his new caregiver, Mandy. She came to them with great recommendations and has given the brilliant, yet lonely, widower a new lease on life—though he is gossiping about the locals’ love affairs instead of debating science and politics.<br/>  <br/> But Phoebe and Robert soon become suspicious of Mandy—her rummaging about in their father’s papers, her strange inheritance from a former client, her habit of speaking her mind no matter the consequences. Then Robert discovers that their father has changed his will. Suddenly Mandy seems more devil than angel . . .<br/>  <br/> For the first time in years, Phoebe and Robert are bonding over something—even if it is their mutual distrust of Mandy. And what happens next will make the siblings question everything they thought they knew about their parents—and themselves.<br/>  <br/> “Moggach addresses an all too common nightmare with ruthless honesty and sublime wit—<i>The Carer </i>is one of the funniest novels I have read for ages.” —<i>The Times</i> (London)<br/>  <br/> “Unputdownable, fun and tender with characters that jump off the page. Perfection.” —Marian Keyes, international-bestselling author of <i>Again, Rachel</i><br/>  <br/> “Joyous . . . a sustained satire on smug middle-class mores.” —<i>Daily Mail</i><br/>  <br/> “The most endearing of humorists, Deborah Moggach casts a penetrating eye on our foibles and fantasies. Neither ageing, nor death—as <i>The Carer</i> so beautifully demonstrates—can resist her comic scrutiny.” —Lisa Appignanesi, award-winning author of <i>Mad, Bad, and Sad</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah Moggach
      </h2>
      
      <p class="authorDescription body article">Deborah Moggach is an English novelist and screenwriter. She graduated from Bristol University, trained as a teacher, and then worked at Oxford University Press. In the mid-seventies, Moggach moved to Pakistan for two years, where she started composing articles for Pakistani newspapers and her first novel, <I>You Must Be Sisters</I>. Her novels <I>The Best Exotic Marigold Hotel</I> and <I>Tulip Fever</I> were adapted for film in 2011 and 2017 respectively.<BR /><BR /> &#8203;Moggach began writing screenplays in the mid-eighties. Her screenplay for an adaption of <I>Pride &amp; Prejudice</I> starring Keira Knightley received a BAFTA nomination, and she won a Writers Guild Award for her adaptation of Anne Fine&rsquo;s <I>Goggle-Eyes</I>. She has served as Chair of the Management Committee for the Society of Authors and worked for PEN&rsquo;s Executive Committee, as well as being a Fellow of the Royal Society of Literature. Moggach currently lives in the Welsh Marches with her husband.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6abb7553